
<div style="position:relative; z-index: 100; width: 100%;    ">
<nav class="navbar navbar-expand-md fixed-top py-0">
  <div class="container">
    <a class="navbar-brand " href="#"><img class="img-fluid lozad" src="assets/img/logo.png"></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto">
      

         <li class="nav-item">
    <a class="nav-link" [routerLink]="['']">Home</a>
  </li>

  
   <li class="nav-item">
    <a class="nav-link"  href="assets/staticpages/network/index.html"
      >Network</a
    >
  </li>
   <li class="nav-item"  >
    <a class="nav-link" href="assets/staticpages/home/index.html"
      >Hub</a
    >
  </li>

         <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/cf']"
                  >Card Features</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/package']"
                  >View Services</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/ai']"
                  >Additional Features</a
                >
              </li>
      </ul>
    </div>
  </div>
</nav>
</div>


<!----end navbar--->

<section id="profit">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_umages/00.jpg" alt="Image">
          <!-- <h3 class="text-center">Air Combat Command</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_umages/01.jpg" alt="image">
          <!-- <h3 class="text-center">Air Force Military Soldiers</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/02.jpg" alt="Image">
          <!-- <h3 class="text-center">Davis Monthan Air Force Base</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_umages/2.jpg" alt="Image">
          <!-- <h3 class="text-center">Female dress blues</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_umages/03.jpg" alt="Image">
          <!-- <h3 class="text-center">GAO Military women</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/3.jpg" alt="Image">
          <!-- <h3 class="text-center">Marine Corps</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_umages/04.jpg" alt="Image">
          <!-- <h3 class="text-center">Marines male & female </h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_umages/05.jpg" alt="Image">
          <!-- <h3 class="text-center">Air Force Training</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/5.jpg" alt="Image">
          <!-- <h3 class="text-center">First female MEU sergeant major</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/10.jpg" alt="Image">
          <!-- <h3 class="text-center">First female MEU sergeant major</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/11.jpg" alt="Image">
          <!-- <h3 class="text-center">First female MEU sergeant major</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="non-profit" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/12.jpg" alt="Image">
          <!-- <h3 class="text-center">First female MEU sergeant major</h3> -->
        </div>
      </div>
    </div>
  </div>
</section>

<!---LGBTQ SECTION---->


<section>
  <div class="resident  pt-5 bg-light">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-9 ps-md-0 mb-5" data-aos="flip-down">
          <div class="membership-cards">
          <div class="tribe mt-md-5 card mb-5" id="tribe">
            <h2 class="fw-bold">Welcome to LGBTQ Hub — Where Identity Meets Innovation</h2>
            <p class="fs-4 fw-bold">
              Welcome to the Gateway of Visibility, Safety & Progress
            </p>
            <p data-aos="fade-up">Now that you’ve explored what’s inside your digital gated community—a secure, affirming space free from discrimination, harassment, and bias—you’ve arrived at the registration page.</p>
            
            <p data-aos="fade-up">This is where you officially enroll for your LGBTQ Hub Digital Membership Card, unlocking full access to a connected ecosystem of LGBTQ+-led platforms, business tools, and growth opportunities—all in one inclusive space.</p>

            <p data-aos="fade-up">Whether you’re a queer creator, entrepreneur, community organizer, ally, advocate, or LGBTQ+ youth looking to grow, share, and thrive—we’ve created a digital network designed for you. Just select “Register” to begin.</p>

            <p data-aos="fade-up">LGBTQ Hub is more than a platform — it’s your digital safe space for visibility, collaboration, and building bold futures.</p>
            <p class="fs-4"><strong>For just $9.99/month, members get access to:</strong></p>
            <ul class="">
              <li data-aos="fade-up">Livestreams featuring LGBTQ+ leaders, creators, and educators</li>
              <li data-aos="fade-up">Personalized e-commerce stores for art, products, courses, and services</li>
              <li data-aos="fade-up">Secure, encrypted messaging with allies, collaborators, and community members</li>
              <li data-aos="fade-up">Weekly giveaways, grants, and digital resources</li>
              <li data-aos="fade-up">Branding and marketing tools to grow your passion or purpose project</li>
              <li data-aos="fade-up">Gated community spaces for privacy, mental wellness, and connection</li>
            </ul>
          <div class="haven" id="haven" *ngIf="showMore">

            <h3 class="fw-bold my-4" data-aos="fade-up">
              Why LGBTQ Hub?
            </h3>
            <p>Because we believe in investing in voices that matter—and protecting the dignity, safety, and self-expression of our community in digital spaces.</p>
            <p>Each month, your membership helps fund:</p>
            <ul class="">
              <li data-aos="fade-up">Scholarships for LGBTQ+ youth, students, and aspiring leaders</li>
              <li data-aos="fade-up">Microgrants for queer-owned startups, mutual aid projects, and nonprofits</li>
              <li data-aos="fade-up">Gift cards & vouchers for LGBTQ+-friendly businesses and creators</li>
              <li data-aos="fade-up">Free promotional support for queer artists, authors, influencers, and entrepreneurs</li>
            </ul>

            <h3 class="fw-bold my-4">For LGBTQ+ Businesses, Creators & Sponsors</h3>

            <p data-aos="fade-up">
              <strong>Start for just $49.99/month to:</strong> 
            </p>
            <ul>
                  <li class="fw-bold">Be featured in our exclusive Queer Business Directory</li>
                  <li class="fw-bold">Receive spotlight promotion during livestreams, giveaways, and community events</li>
                  <li class="fw-bold">Partner with LGBTQ+ influencers and advocates to amplify your mission</li>
                  <li class="fw-bold">Access premium digital marketing support in a bias-free environment</li>
                </ul>

                <h3 class="fw-bold my-4">
                  Powered by UMYO Wall Street of Technology
                </h3>
                <p>LGBTQ Hub is tech-driven and community-built, combining innovation and inclusion. From e-commerce to livestreams, mentorship to marketing—we help LGBTQ+ creatives, founders, and change-makers thrive without compromise.</p>
                <p>This isn’t just another app — it’s a movement for digital equality, creativity, and collaboration.</p>

                <p>If you're ready to grow your identity-aligned brand, connect with a powerful queer community, and take up space boldly — LGBTQ Hub is your launchpad for impact.</p>



            <h3 class="fw-bold my-4">
              Call to Action
            </h3>

            <p> <b>Join LGBTQ Hub for just $9.99/month<br>Launch your queer-owned brand or business for $49.99/month</b></p>
            <p>You’ll gain access to:</p>

                <ul>
                  <li class="fw-bold">Custom LGBTQ+-centered business & creative tools</li>
                  <li class="fw-bold">Weekly community giveaways</li>
                  <li class="fw-bold">Your own branded online storefront or digital profile</li>
                  <li class="fw-bold">Connections to an affirming, global network of queer innovators</li>
                </ul>

                <p><strong>No ads. No hate. No algorithms working against you.</strong></p>
                <p class="lead"> Just pride, purpose, and progress.</p>

                <h3 class="fw-bold my-4">
                  Join the Movement
                </h3>

                 <p> <b>Explore LGBTQ Hub<br>Power the Future of Queer-Led Digital Spaces</b></p>

            
            <button  (click)="toggleContent()"  class="btn btn-hover-purple border-dark gap-2 mt-4" data-aos="fade-up">
            Read Less
            </button>
            </div>
            <button  *ngIf="!showMore" (click)="toggleContent()"  class="btn btn-hover-purple border-dark gap-2 mt-4">
            Read More
            </button>
          </div>
         </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!---END LGBTQ SECTION---->

<!----POWER SECTION--->
<section  class="power">
       <div class="container-fluid srice py-5">
            <div class="container py-5">
        <h1 class="text-white text-center  mb-3" style="font-weight: 600; ">UMYO LGBTQ Hub Members </h1>
        <div class="row">
             <div class="col-lg-5 mt-5">
                <h4 class="mb-4 text-white">Search For The UMYO LGBTQ Hub</h4>
                
                  
                <form [formGroup]="form2" class="text-center">
            <div class="row">
              

<div class="col-lg-6 mb-4">
                <input
                  type="name"
                  formControlName="selectedName"
                  class="form-control"
                  placeholder="Name"
                />
              </div>

              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedBusiness"
                >
                  <option selected value="" disabled>BUSINESS TYPE</option>
                  <option *ngFor="let item of businessType" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedLocation"
                >
                  <option selected value="" disabled>Location</option>
                  <option *ngFor="let item of location" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="col-lg-6 mb-4">
                <input
                  type="text"
                  formControlName="selectedCity"
                  class="form-control"
                  placeholder="City"
                />
              </div>

              <div class="col-lg-6">
                <h4 class="mb-4 text-white text-center">
                  I PLEDGE TO REPORT VIOLENT CRIMES
                </h4>
              </div>

              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedRace"
                >
                  <option selected value="" disabled>Race</option>
                  <option *ngFor="let item of race" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="col-lg-6 mb-4">
                <select
                  class="form-select"
                  aria-label="Default select example"
                  formControlName="selectedGender"
                >
                  <option selected value="" disabled>Gender</option>
                  <option *ngFor="let item of gender" [value]="item">
                    {{ item }}
                  </option>
                </select>
              </div>

              <div class="col-lg-6 mb-4">
                <button
                  type="submit"
                  class="btn btn-light text-white fw-semibold py-2 px-5 w-100 border-0"
                  (click)="searchCards()"
                  [disabled]="!form2.valid"
                >
                  Search
                </button>
              </div>
            </div>
          </form>

             


                
<div  class="btn-light rounded text-white py-2 px-3 my-5">
                  <p  class="text-white mb-4">Cards:</p>
                </div>
                                 <p
              class="text-white mb-4"
              style="cursor: pointer"
              [routerLink]="'/cards/share-card/' + card.id"
              *ngFor="let card of cardsSearched"
            >
              {{ card.cardTitle }}
            </p>
            </div>
            <div class="col-lg-7 mt-5">
             <div class="d-flex position-relative justify-content-center">
              <!-- Nav pills -->
             <div class="element">
                <button                           [class.active]="showLoginTab"
      (click)="checkRoute()" class="btn active">Login</button>
                <button (click)="checkRoute()"
                  [class.active]="!showLoginTab" class="btn">Register</button>
              </div>

              <!-- Tab panes -->
              <div class="tab-content rounded p-4 bg-light">
                
                <!-- Login Tab -->
<div                 [class.active]="showLoginTab" [class.inactive]="!showLoginTab"
 id="login" class="login">
                   <div class="text-center mb-5">
       <h1  class="text-center">UMYO For UMYO LGBTQ</h1>
                  <p  class="text-center"> Register to Connect with UMYO LGBTQ </p>
                  </div>

                  <h2 class=" mb-3" >Login</h2>
                  <div class="row">
                                            <form [formGroup]="form">
                  <div class="row">
                   <div class="col-md-12 mb-5">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Email
                          <sup style="color: red; font-size: 20px">*</sup>
                        </label>
                        <input
                          type="email"
                          id="email"
                          class="form-control"
                          formControlName="email"
                          required
                        />
                        <div
                          *ngIf="
                            form.get('email')?.hasError('required') &&
                            form.get('email')?.touched
                          "
                          class="text-danger"
                        >
                          Email is required.
                        </div>
                        <div
                          *ngIf="
                            form.get('email')?.hasError('email') &&
                            form.get('email')?.touched
                          "
                          class="text-danger"
                        >
                          Invalid email format.
                        </div>
                      </div>
                    </div>


                    <div class="col-md-12 mb-5">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Password<sup style="color: red; font-size: 20px"
                            >*</sup
                          >
                        </label>
                        <input
                          type="password"
                          id="password"
                          class="form-control"
                          formControlName="password"
                          required
                        />
                        <div
                          *ngIf="
                            form.get('password')?.hasError('required') &&
                            form.get('password')?.touched
                          "
                          class="text-danger"
                        >
                          Password is required.
                        </div>
                      </div>
                      <div class="form-group" style="padding-top: 10px">
                        <label
                          style="
                            font-size: 16px;
                            font-weight: 400;
                            text-decoration: underline;
                            cursor: pointer;
                          "
                          [routerLink]="['/forgot-password']"
                          >Forgot Password?
                        </label>
                      </div>
                    </div>


                    <div class="form-check ms-3 my-3">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label fw-bold" for="flexCheckDefault">
                        Are you above 13 years old?
                      </label>
                    </div>
                    <div class="text-center">
                      <button       (click)="openAgeModal('login')"
                                        [disabled]="!form.valid" class="btn  text-white submit py-3 px-5" >Submit</button>
                    </div>
                  </div>

</form>
                  </div>
                </div>

                <!-- Register Tab -->
  <div                 [class.active]="!showLoginTab" [class.inactive]="showLoginTab"
 id="regis" class="register" >             
 
                <form [formGroup]="form3">
                     <div class="text-center mb-5">
                       <h1>UMYO LGBTQ</h1>
                    </div>
                    <div class="row text-center mb-5">
                      <div class="col-md-3">
                        <p>Starting at</p>
                        <h1>$9.99</h1>
                        <p>Monthly</p>
                      </div>
                      <div class="col-md-1 d-none d-lg-block">
                        <div style="height: 100%; border-left: 2px solid #ccc;"></div>
                      </div>
                      <div class="col-md-6">
                        <p class="text-start">Includes:</p>
                        <ul class="text-start">
                          <li>40% off all LGBTQ products</li>
                          <li>3 free property listings per agent</li>
                          <li>Free standard CRM integrations</li>
                        </ul>
                      </div>
                    </div>

                    <h2 class=" mb-4">Register</h2>
                    <div class="row">
                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >First Name
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerFirstName"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerFirstName')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Last Name
                          <sup style="color: red; font-size: 20px">*</sup>
                        </label>
                        <input
                          type="text"
                          formControlName="registerLastName"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerLastName')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                       <div class="col-md-12 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Phone Number
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerPhone"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerPhone')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>


                      <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Email
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="email"
                          formControlName="registerEmail"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerEmail')?.touched ||
                                !form3.get('registerEmail')?.valid) &&
                              submitButtonClicked &&
                              (!form3.valid || form3.hasError('emailMismatch'))
                          }"
                        />
                      </div>
                    </div>


                       <div class="col-md-6 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Confirm Email
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="email"
                          formControlName="registerConfirmEmail"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerConfirmEmail')?.touched ||
                                !form3.get('registerConfirmEmail')?.valid) &&
                              submitButtonClicked &&
                              (!form3.valid || form3.hasError('emailMismatch'))
                          }"
                        />
                      </div>
                    </div>


                       <div class="col-md-12 mb-3">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >Password<sup style="color: red; font-size: 20px"
                            >* </sup
                          ><sup style="color: red; font-size: 14px"
                            >( Length Should be greater than 6 )</sup
                          >
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          required
                          formControlName="registerPassword"
                          [ngClass]="{
                            'invalid-input':
                              (!form3.get('registerPassword')?.touched ||
                                !form3.get('registerPassword')?.valid) &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

<div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >BUSINESS TYPE<sup style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerBusiness')?.touched ||
                              !form3.get('registerBusiness')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerBusiness"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option
                          *ngFor="let item of businessType"
                          [value]="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <div class="form-group">
                        <label style="font-size: 20px; font-weight: 600"
                          >City
                          <sup style="color: red; font-size: 20px"
                            >*</sup
                          ></label
                        >
                        <input
                          type="text"
                          formControlName="registerCityType"
                          class="form-control"
                          required
                          [ngClass]="{
                            'invalid-input':
                              !form3.get('registerCityType')?.touched &&
                              submitButtonClicked &&
                              !form3.valid
                          }"
                        />
                      </div>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Race<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerRaceType')?.touched ||
                              !form3.get('registerRaceType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerRaceType"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>

                        <option *ngFor="let item of race" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Gender<sup style="color: red; font-size: 20px">*</sup>
                      </label>
                      <select
                        formControlName="registerGenderType"
                        class="form-select"
                        aria-label="Default select example"
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerGenderType')?.touched ||
                              !form3.get('registerGenderType')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of gender" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>

                    <div class="col-lg-6 mb-4">
                      <label style="font-size: 20px; font-weight: 600"
                        >Location<sup style="color: red; font-size: 20px"
                          >*</sup
                        >
                      </label>
                      <select
                        [ngClass]="{
                          'invalid-input':
                            (!form3.get('registerLocation')?.touched ||
                              !form3.get('registerLocation')?.valid) &&
                            submitButtonClicked &&
                            !form3.valid
                        }"
                        required
                        formControlName="registerLocation"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="" disabled selected>
                          Please Select
                        </option>
                        <option *ngFor="let item of location" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>

                     


                       


                      <div class="col-md-12 mb-3">
                        <label class="form-label" style="font-size: 18px;">Enter Referral Code </label>
                        <input                           formControlName="registerReferralCode"
 type="text" class="form-control" >
                      </div>
                      <div class="col-md-12 mb-3">
                        <div class="form-check ms-3 my-3">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label fw-bold" for="flexCheckDefault">
                        Are you above 13 years old?
                      </label>
                    </div>
                      </div>
                    </div>
                    <div (click)="submitForm()" class="text-center">
                      <button      (click)="openAgeModal('signup')"
                      [disabled]="!form3.valid"
                                         type="submit" class="btn  text-white submit py-3 px-5" >Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            </div>
        </div>
    </div>
  </div>
     </section>

<!---END POWER SECTION---->

<section id="profit">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_umages/06.jpg" alt="Image">
          <!-- <h3 class="text-center">The Last Skirt Mandate in Marine Corps</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-up">
          <img class="img-fluid lozad" src="assets/img/directory_umages/6.jpg" alt="Image">
          <!-- <h3 class="text-center">Units need more fit, disciplined soldiers</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-left">
          <img class="img-fluid lozad" src="assets/img/directory_umages/07.jpg" alt="Image">
          <!-- <h3 class="text-center">US Marine Corps</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images" data-aos="fade-right">
          <img class="img-fluid lozad" src="assets/img/directory_umages/7.jpg" alt="Image">
          <!-- <h3 class="text-center">Usmc new female dress blues new arrivals</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images  " data-aos="fade-up" >
          <img class="img-fluid lozad w-auto mx-auto d-block" src="assets/img/directory_umages/09.jpg" alt="Image">
          <!-- <h3 class="text-center">U.S Marine Corps</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images  " data-aos="fade-left" style="width: fit-content;">
          <img class="img-fluid lozad w-auto mx-auto d-block" src="assets/img/directory_umages/9.jpg" alt="Image">
          <!-- <h3 class="text-center">First female Marine Corps</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images  " data-aos="fade-left" style="width: fit-content;">
          <img class="img-fluid lozad w-auto mx-auto d-block" src="assets/img/directory_umages/13.jpg" alt="Image">
          <!-- <h3 class="text-center">First female Marine Corps</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images  " data-aos="fade-left" style="width: fit-content;">
          <img class="img-fluid lozad w-auto mx-auto d-block" src="assets/img/directory_umages/15.jpg" alt="Image">
          <!-- <h3 class="text-center">First female Marine Corps</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images  " data-aos="fade-left" style="width: fit-content;">
          <img class="img-fluid lozad w-auto mx-auto d-block" src="assets/img/directory_umages/Balck-Pride.jpg" alt="Image">
          <!-- <h3 class="text-center">First female Marine Corps</h3> -->
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-5">
        <div class="UMYO Sports_images  " data-aos="fade-left" style="width: fit-content;">
          <img class="img-fluid lozad w-auto mx-auto d-block" src="assets/img/directory_umages/LBGTQ.jpeg" alt="Image">
          <!-- <h3 class="text-center">First female Marine Corps</h3> -->
        </div>
      </div>

    </div>
  </div>
</section>

<!----END CARDS SECTION--->

<footer>
  <div class="container">
    <h3>Own Your Platform. Build Your Future. UMYO LGBTQ+ Community.</h3>
    <h6>This is more than just a safe space—it's a transformative hub where identity is celebrated, voices are amplified, and connection fuels growth.</h6>
  </div>
</footer>





<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showPackageModal, 'd-block': showPackageModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Select One Package
        </h5>
        <button type="button" class="close"  style="padding-left:10px;padding-right:10px"(click)="closePackageModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 70vh; overflow-y: scroll">
        <div class="row">
          <div class="col-md-6" *ngFor="let package of packages; let i = index">
            <div class="outerCard" style="min-height: 30vh; cursor: pointer">
              <div
                class="card"
                [ngClass]="{ cardSelect: selectedPackage === package }"
                (click)="selectPackage(package)"
              >
                <div class="card-body">
                  <h5 class="card-title" style="color: rgb(35, 149, 243)">
                    $
                    {{ package.net_price ? package.net_price : package.price }}
                    <sup
                      style="
                        text-decoration: line-through;
                        font-size: 20px;
                        color: gray;
                        padding-left: 15px;
                      "
                      *ngIf="package.net_price"
                      >{{ package.price }}</sup
                    >
                  </h5>
                  <p class="card-text">Cards Limit: {{ package.limit }}</p>
                  <p class="card-duration">Duration: {{ package.expire_in }}</p>

                  <div
                    class="description-container"
                    style="max-height: 100px; overflow-y: auto"
                  >
                    <p class="card-description">{{ package.description }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100" *ngIf="(i + 1) % 2 === 0"></div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          (click)="closePackageModal()"
          type="button"
          class="btn btn-secondary"
        >
          Close
        </button>

        <div
          *ngIf="selectedPackage?.price != '0'"
          [ngClass]="{
            hidden: selectedPackage == null || selectedPackage?.price == '0',
            paymentButtons: selectedPackage != null
          }"
        >
          <!-- <div id="paypal-button-container"></div> -->
          <!-- hide stripe  -->
          <!-- <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="openStripeModal()"
          >
            Stripe
          </button> -->
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="paypalClick()"
          >
            paypal
          </button>
        </div>
        <div *ngIf="selectedPackage?.price == '0'">
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="continuePaymentButton()"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showLoadingModal, 'd-block': showLoadingModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>{{ paypalTitleMessage }}</h3>
          <p style="padding-top: 15px">{{ paypalMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- stripe modal  -->

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showStripeModal, 'd-block': showStripeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Pay Through Stripe
        </h5>
        <button type="button" class="close"  style="padding-left:10px;padding-right:10px"(click)="closeStripeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <form class="checkout-form" [formGroup]="paymentForm">
            <h3>
              Amount
              {{
                selectedPackage?.net_price
                  ? selectedPackage?.net_price
                  : selectedPackage?.price
              }}
            </h3>
            <div class="row">
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-number"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >Card Number 16 Digit (Without Dashes)</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="card-number"
                    data-stripe-element="cardNumber"
                    formControlName="cardNumber"
                    placeholder="XXXXXXXXXXXXXXXX"
                  />
                </div>
              </div>
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-expiry"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >Expiration Date in (MM/YY) Format including /
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="card-expiry"
                    data-stripe-element="expiryDate"
                    formControlName="expiryDate"
                    placeholder="MM/YY"
                  />
                </div>
              </div>
              <div class="col-md-12" style="padding-top: 17px">
                <div class="form-group">
                  <label
                    for="card-cvc"
                    style="
                      font-size: 17px;
                      font-weight: 600;
                      padding-bottom: 8px;
                    "
                    >CVC 3 Digit</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="card-cvc"
                    data-stripe-element="cvc"
                    formControlName="cvc"
                    placeholder="XXX"
                  />
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div
                class="col-md-12"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding-top: 10px;
                "
              >
                <button
                  type="submit"
                  class="btn btn-primary"
                  data-bs-toggle="modal"
                  id="pay-button"
                  (click)="pay()"
                >
                  Pay Now
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeStripeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showAgeModal, 'd-block': showAgeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>Are You 18+ of your age?</h3>
        </div>
        <p style="padding: 8px">
          You must be at least 13 years old to use the Service. However,
          children of all ages may use the Service and PLTalk Kids (where
          available) if enabled by a parent or legal guardian. Permission by
          Parent or Guardian If you are under 18, you represent that you have
          your parent or guardian’s permission to use the Service. Please have
          them read this Agreement with you. If you are a parent or legal
          guardian of a user under the age of 18, by allowing your child to use
          the Service, you are subject to the terms of this Agreement and
          responsible for your child’s activity on the Service. You can find
          tools and resources to help you manage your family’s experience on
          PLTalk in our Help Center
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="confirmAge()">
          Yes
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeAgeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
